'use client'
import classNames from 'classnames'
import { TypographyV2 as Typography } from 'components/Typography/TypographyV2'

function Eyebrow({
  className,
  black = false,
  useCustomColor = false,
  variant = 'bodySm',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  classNameText,
  ...restProps
}) {
  return (
    <Typography
      variant={variant}
      fontWeight="bold"
      className={classNames(
        'group',
        'leading-[16.6px]',
        'pb-4',
        !useCustomColor ? (black ? 'text-[#5c708a]' : 'text-[#30f]') : '',
        'text-center', //by default should be center align
        'tracking-[0.25em]',
        'uppercase',
        className
      )}
      {...restProps}
    />
  )
}

export { Eyebrow }
